import { render, staticRenderFns } from "./KanbanWidget.vue?vue&type=template&id=ab6d5966&scoped=true"
import script from "./KanbanWidget.vue?vue&type=script&lang=js"
export * from "./KanbanWidget.vue?vue&type=script&lang=js"
import style0 from "./KanbanWidget.vue?vue&type=style&index=0&id=ab6d5966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6d5966",
  null
  
)

export default component.exports